import React, { useMemo } from "react";
import { observable } from "mobx";
import { observer } from "mobx-react";
import { VimeoProps, PauseEvent } from "@u-wave/react-vimeo";

import I100Play from "assets/icons/I100Play";

import IconButton from "components/IconButton";

import { formatDurationOnlyNumbers } from "utils/common";

import {
  Background,
  Container,
  Control,
  Duration,
  DurationText,
  Image,
  Vimeo,
} from "./styles";

type Props = {
  imageUrl: string;
  duration: number;
  logEvent?: any;
} & VimeoProps;

const Video: React.FC<Props> = observer((props) => {
  const { imageUrl, duration, logEvent, onPause: onPauseProp } = props;

  const state = useMemo(
    () =>
      observable({
        needThumbnail: true,
        paused: true,
      }),
    []
  );

  const durationText = useMemo(
    () => formatDurationOnlyNumbers(duration),
    [duration]
  );

  const playVideo = () => {
    logEvent?.();
    state.paused = false;
    state.needThumbnail = false;
  };

  const onPause = (event: PauseEvent) => {
    state.paused = true;
    onPauseProp?.(event);
  };

  return (
    <Container>
      {state.needThumbnail ? (
        <>
          <Background />
          <Image imageUrl={imageUrl} />
          <Control>
            <IconButton icon={<I100Play />} onClick={playVideo} />
          </Control>
          <Duration>
            <DurationText>{durationText}</DurationText>
          </Duration>
        </>
      ) : null}
      <Vimeo
        {...props}
        onPause={onPause}
        paused={state.paused}
        style={{ borderRadius: "10px" }}
      />
    </Container>
  );
});

export default Video;

